// Local helpers that don't need the AI: profile answers for applications and a plain email template
// used when the AI is unavailable.

const fullName = (profile) =>
  [profile.firstName, profile.lastName].filter(Boolean).join(" ");

export function profileFields(profile) {
  return [
    { id: "name", label: "Full name", value: fullName(profile) },
    { id: "email", label: "Email", value: profile.email },
    { id: "phone", label: "Phone", value: profile.phone },
    { id: "location", label: "Current location", value: profile.location },
    { id: "linkedin", label: "LinkedIn URL", value: profile.linkedin },
    { id: "github", label: "GitHub", value: profile.github },
    { id: "portfolio", label: "Website / portfolio", value: profile.portfolio },
    {
      id: "auth",
      label: "Are you authorized to work in the US?",
      value: profile.workAuthorization,
    },
    {
      id: "sponsor",
      label: "Will you require visa sponsorship?",
      value: profile.needsSponsorship,
    },
    {
      id: "salary",
      label: "Salary expectations",
      value: profile.salaryExpectation,
    },
    { id: "start", label: "Earliest start date", value: profile.startDate },
  ].map((f) => ({ ...f, value: f.value || "" }));
}

// Fills {{placeholders}} in the user's own outreach template, for when the AI isn't available.
export function fillTemplate(template, { job, contact, profile }) {
  const name = fullName(profile) || "Your Name";
  const values = {
    company: job.company,
    job_title: job.title,
    recipient_name: contact.name,
    hiring_manager: contact.name,
    my_name: name,
  };
  let out = String(template || "");
  for (const [key, value] of Object.entries(values))
    out = out.replaceAll(`{{${key}}}`, value);
  return out.replace(/\{\{[^}]+\}\}/g, "").trim();
}

export function templateEmail({ job, contact, profile, template = "" }) {
  const name = fullName(profile) || "Your Name";
  const firstName = contact.name.split(" ")[0];
  if (template?.trim() && !contact.emailed) {
    return {
      subject: `${job.title} application - ${name}`,
      body: fillTemplate(template, { job, contact, profile }),
    };
  }
  if (contact.emailed) {
    return {
      subject: `Re: ${job.title} application - ${name}`,
      body: `Hi ${firstName},\n\nI wanted to follow up on my application for the ${job.title} role. I'm still very interested and happy to share anything else that would help.\n\nThanks again,\n${name}`,
    };
  }
  return {
    subject: `${job.title} application - ${name}`,
    body: `Hi ${firstName},\n\nI recently applied for the ${job.title} position at ${job.company} and wanted to reach out directly. I'd love the chance to learn more about the role and share how my experience could help the team.\n\nWould you be open to a quick chat this week?\n\nThanks so much,\n${name}${profile.linkedin ? `\n${profile.linkedin}` : ""}`,
  };
}
